"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionPayload = void 0;
const anchor_1 = require("@coral-xyz/anchor");
/**
 * A executable payload that holds transaction
 */
class TransactionPayload {
    /**
     * Create instance of Transaction Payload
     * @param _connection Solana web3 connnection
     * @param _errors Program errors map
     * @param blockhash Blockhash used in transaction
     * @param lastValidBlockHeight Last valid block height used in transaction
     * @param transaction Transaction
     * @param signers Array of signers for transaction. Leave empty if none
     * @param _signTransaction A function that signs and return transaction
     */
    constructor(_connection, _errors, blockhash, lastValidBlockHeight, transaction, signers, _signTransaction) {
        this._connection = _connection;
        this._errors = _errors;
        this.blockhash = blockhash;
        this.lastValidBlockHeight = lastValidBlockHeight;
        this.transaction = transaction;
        this.signers = signers;
        this._signTransaction = _signTransaction;
    }
    /**
     * Signs, send and confim transaction
     * * `Note`: requires signTransaction while creating instance of this object.
     * @param options solana confirm options
     * @returns
     */
    execute(options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._signTransaction) {
                throw new Error("signTransaction is required to execute transaction payload.");
            }
            this.transaction.message.recentBlockhash = this.blockhash;
            if (this.signers.length > 0) {
                this.transaction.sign(this.signers);
            }
            const signedTransaction = yield this._signTransaction(this.transaction);
            try {
                const signature = yield this._connection.sendRawTransaction(signedTransaction.serialize(), options);
                console.debug("signatue: %s", signature);
                const response = yield this._connection.confirmTransaction({
                    signature,
                    blockhash: this.blockhash,
                    lastValidBlockHeight: this.lastValidBlockHeight,
                }, options === null || options === void 0 ? void 0 : options.commitment);
                if (response.value.err) {
                    const err = response.value.err;
                    if (typeof err === "string") {
                        throw new Error("Failed to confirm transaction: " + err);
                    }
                    else {
                        console.debug("confirm transaction err: " + JSON.stringify(err));
                        throw new Error("Failed to confirm transaction");
                    }
                }
                return signature;
            }
            catch (err) {
                const translatedError = (0, anchor_1.translateError)(err, this._errors);
                if (translatedError && translatedError instanceof Error) {
                    throw translatedError;
                }
                console.debug("transalated error:", translatedError);
                console.debug("Throwing error as it is.");
                throw err;
            }
        });
    }
}
exports.TransactionPayload = TransactionPayload;
